import { Base } from "../../framework/base";
import { AppReportTemplateFormModel, IAppReportTemplateFormModel } from "./appReportTemplateFormModel";

export interface IAppReportTemplateNew {
    systemReportTemplates: IAppReportTemplateFormModel[];
    companyReportTemplates: IAppReportTemplateFormModel[];
}

export class AppReportTemplateNew implements IAppReportTemplateNew {
    systemReportTemplates: AppReportTemplateFormModel[];
    companyReportTemplates: AppReportTemplateFormModel[];

    constructor();
    constructor(obj: IAppReportTemplateNew);
    constructor(obj?: any) {
        this.systemReportTemplates = Base.getTypedArray(obj?.systemReportTemplates, AppReportTemplateFormModel);
        this.companyReportTemplates = Base.getTypedArray(obj?.companyReportTemplates, AppReportTemplateFormModel);
    }
}